import React from 'react';
import PropTypes from 'prop-types';
import { 
  Drawer,
  Form, 
  Input, 
  InputNumber, 
  DatePicker, 
  // TimePicker, 
  Row, 
  Col, 
  Button, 
  Select,
  Table,
  Popconfirm,
  Icon, 
} from 'antd';
import TableTimePicker from 'components/form/TableTimePicker.jsx';
import { generateDateFromUser } from 'util/DateGenerator.jsx';
import { shortDate, shortTime } from 'util/DateFormatter.jsx';
import { createOptions, generateRange } from 'util/FormUtils.jsx';

const FormItem = Form.Item;
const Option = Select.Option;

function SaveButton({ occurrencesValidation, onSaveDrawer }) {
  if (occurrencesValidation) {
    return (
      <button
        type="button"
        className="btn btn-primary"
        onClick={() => onSaveDrawer()}
      >
        Salva
      </button>
    );
  }
  return (
    <button
      type="button"
      className="btn btn-primary disabled"
    >
      Salva
    </button>
  );
}

SaveButton.propTypes = {
  occurrencesValidation: PropTypes.bool.isRequired,
  onSaveDrawer: PropTypes.func.isRequired,
};

class WeeklySchedule extends React.Component {
  constructor(props) {
    super(props);
    console.log('array occorrenze gia registrate:', this.props.registryOccurrences);
    this.state = {
      indexRow: 0,
      isOpen: false,
      formIsOpen: false,
      tpsIsOpen: [],
      rules: [],
      selected: null,
      occurrences: [],
      startDate: null,
      dayrow: 0,
      hasErrors: false,
    };
  }

  openDrawer = () => {
    this.setState({
      isOpen: true,
    });
  }

  openForm = () => {
    this.setState({
      formIsOpen: true,
    });
  }

  closeForm = () => {
    this.setState({
      formIsOpen: false,
    });
  }

  handleAddRow = () => {
    const occorrenze = this.state.occurrences;
    const newOccurrence = {
      rId: occorrenze.length + 1,
      giorno: null,
      orainizio: null,
      durata: null,
      modalita: null,
      aula: '',
      sede: '',
      idFormaDid: '',
    };
    occorrenze.push(newOccurrence);
    // console.warn('occorrenze finali:', occorrenze);
    const tps = this.state.tpsIsOpen;
    tps.push({ id: `tp.${occorrenze.length + 1}` , open: false});
    this.setState({
      ...this.state,
      occurrences: occorrenze,
      hasErrors: false,
      tpsIsOpen: tps,
    });
  };

  handleDeleteRow = (index) => {
    const occorrenze = this.state.occurrences;
    const tps = this.state.tpsIsOpen;
    occorrenze.splice(index,1);
    tps.splice(index, 1);
    this.setState({
      ...this.state,
      occurrences: occorrenze,
      tpsIsOpen: tps,
    });
  }

  saveDrawer = (e) => {
    e.preventDefault();
    this.props.form.validateFields((errors, values) => {
      if (errors) {
        this.setState({
          ...this.state,
          hasErrors: true,
        });
        return;
      }
      if (this.state.occurrences.length === 0) {
        this.setState({
          ...this.state,
          hasErrors: true,
        });
        return;
      }
      console.warn('dati della form:', values);
      // const formData = this.props.form.getFieldsValue();
      const date = { startDate: values.startDate, endDate: values.endDate };
      const generatedOccurrences = generateDateFromUser(date, values.occorrenze);
      console.warn('occorrenze generate:', generatedOccurrences);
      this.props.onSaveClick(this.props.registryInfo.idRegistro, generatedOccurrences);
      this.props.form.resetFields();
      this.setState({
        isOpen: false,
        hasErrors: false,
        formIsOpen: false,
        tpsIsOpen: [],
        occurrences: [],
        selected: null,
        startDate: null,
        endDate: null,
      });
    })
  }

  closeDrawer = () => {
    this.props.form.resetFields();
    this.setState({
      isOpen: false,
      formIsOpen: false,
      tpsIsOpen: [],
      occurrences: [],
      selected: null,
      startDate: null,
      endDate: null,
      hasErrors: false,
    });
  }

  openTimepicker = (index) => {
    console.warn('debug openTimepicker:',index);
    const tps = this.state.tpsIsOpen;
    console.warn('debug openTimepicker:', tps[index].open);
    if (!tps[index].open) {
      console.warn('apro panel');
      tps[index].open = true;
      this.setState({
        ...this.state,
        tpsIsOpen: tps,
      });
    }
  }

  closeTimepicker = (index) => {
    const tps = this.state.tpsIsOpen;
    tps[index].open = false;
    this.setState({
      ...this.state,
      tpsIsOpen: tps,
    });
  }

  disabledDate = (current) => {
    current.hours(0).minute(0).second(0);
    const rangeYears = generateRange(
      this.props.registryInfo.annoAccademico,
      this.props.registryInfo.tipoCDL,
      this.props.registryOccurrences,
      this.props.registryInfo.dataChiusuraCopertura
      );
    return current && (current.isSameOrBefore(rangeYears.minDate) || current.isSameOrAfter(rangeYears.maxDate));
  }

  checkEndDate = ( rule, value, callback) => {
    const eDate = this.props.form.getFieldValue('endDate');
    console.warn('stato di startDate:', eDate);
    if (eDate && eDate.isSameOrBefore(value)) {
      callback('Data di inizio posteriore a quella di fine!');
    } else {
      callback();
    }
  }

  checkStartDate = ( rule, value, callback) => {
    const sDate = this.props.form.getFieldValue('startDate');
    console.warn('stato di startDate:', sDate);
    if (sDate && sDate.isSameOrAfter(value)) {
      callback('Data di fine antecedente a quella di inizio!');
    } else {
      callback();
    }
  }



  render() {
    const btnTitle = (this.props.title ? this.props.title.button : 'Attività Multiple');

    const { getFieldDecorator } = this.props.form;
    const rangeyrs = generateRange(
      this.props.registryInfo.annoAccademico, 
      this.props.registryInfo.tipoCDL, 
      this.props.registryOccurrences,
      this.props.registryInfo.dataChiusuraCopertura
      );
    const opts = createOptions(this.props.formeDidScheduled);
    const occorrenze = this.state.occurrences;
    const tableStyle = (this.state.hasErrors ? 'table-error' : '');
    const columns = [
      {
        title: 'Giorno',
        dataIndex: 'giorno',
        render: (value, record, rowIndex) => (
          <Form.Item help="">
            {/* help="" nasconde il messaggio di validazione */}
            {getFieldDecorator(`occorrenze.${rowIndex}.giorno`, {
              rules: [{ required: true, message: '' }],
              initialValue: value,
            })(
              <Select placeholder="Ora">
                <Option value={1}>Lunedì</Option>
                <Option value={2}>Martedì</Option>
                <Option value={3}>Mercoledì</Option>
                <Option value={4}>Giovedì</Option>
                <Option value={5}>Venerdì</Option>
                <Option value={6}>Sabato</Option>
              </Select>)}
          </Form.Item>
        )
      },
      {
        title: 'Ora inizio',
        dataIndex: 'orainizio',
        width: '10%',
        render: (value, record, rowIndex) => (
          <Form.Item help="">
            {/* help="" nasconde il messaggio di validazione */}
            {getFieldDecorator(`occorrenze.${rowIndex}.orainizio`, {
              rules: [{ required: true, message: '' }],
              initialValue: value,
            })(<TableTimePicker/>)}
          </Form.Item>
        ),
      },
      {
        title: 'Durata (ore)',
        dataIndex: 'durata',
        width: '10%',
        render: (value, record, rowIndex) => (
          <Form.Item help="">
            {getFieldDecorator(`occorrenze.${rowIndex}.durata`, {
              rules: [{ required: true }],
              initialValue: value,
            })(<InputNumber step={0.5} min={0} max={12} placeholder="Durata" />)}
          </Form.Item>
        ),
      },
      {
        title: 'Modalita',
        dataIndex: 'modalita',
        render: (value, record, rowIndex) => (
          <Form.Item help="">
            {/* help="" nasconde il messaggio di validazione */}
            {getFieldDecorator(`occorrenze.${rowIndex}.modalita`, {
              initialValue: value,
            })(
              <Select placeholder="Modalità">
                <Option key="nd" value={null}>Non Definito</Option>
                <Option key="sinc" value="sincrona in presenza">Sincrona in presenza</Option>
                <Option key="sinc" value="sincrona online">Sincrona online</Option>
                <Option key="asinc" value="asincrona">Asincrona</Option>
              </Select>)}
          </Form.Item>
        )
      },
      {
        title: 'Aula/Piattaforma',
        dataIndex: 'aula',
        render: (value, record, rowIndex) => (
          <Form.Item help="">
            {getFieldDecorator(`occorrenze.${rowIndex}.aula`, {
              rules: [{ required: true }],
              initialValue: value,
            })(<Input placeholder="Aula" maxLength={40} />)}
          </Form.Item>
        ),
      },
      {
        title: 'Sede',
        dataIndex: 'sede',
        render: (value, record, rowIndex) => (
          <Form.Item help="">
            {getFieldDecorator(`occorrenze.${rowIndex}.sede`, {
              initialValue: value,
            })(<Input placeholder="Sede" maxLength={256} />)}
          </Form.Item>
        ),
      },
      {
        title: 'Forma didattica',
        dataIndex: 'idFormaDid',
        render: (value, record, rowIndex) => (
          <Form.Item help="">
            {getFieldDecorator(`occorrenze.${rowIndex}.idFormaDid`, {
              rules: [{ required: true }],
              initialValue: value,
            })(
              <Select>
                {opts}
              </Select>)}
          </Form.Item>
        ),
      },
      {
        title: '',
          dataIndex: 'operation',
          render: (value, record, rowIndex) => (
            <Popconfirm 
              title="Procedere con la cancellazione dell'attività?" 
              onConfirm={() => this.handleDeleteRow(rowIndex)}
              okText="Sì"
              cancelText="No"
            >
              <Button type="danger">
                <Icon type="delete" />
              </Button>
            </Popconfirm>
          ),
      },
    ];

    return (
      <div style={{ marginRight: '10px', float: 'left' }} >
        <Button size="large" onClick={this.openDrawer}>
          <Icon type="calendar" />
          {btnTitle}
        </Button>
        <Drawer
          title="Inserisci nuove Attività Multiple"
          visible={this.state.isOpen}
          placement="left"
          width="70%"
          maskClosable={false}
          onClose={this.closeDrawer}
        >
          <Form className="simple-form" onSubmit={this.saveDrawer}>
            <h3>Quando:</h3>
            <Row gutter={16}>
              <Col span={8}>
                <FormItem label="Data Inizio">
                  {getFieldDecorator('startDate', { 
                    rules: [{ required: true, message: 'Inserire la data di inizio dell\'attività didattica'},
                    { validator: this.checkEndDate }] 
                    })(
                    <DatePicker 
                      format={shortDate} 
                      disabledDate={this.disabledDate}
                      defaultPickerValue={rangeyrs.minDate}
                      placeholder={'Data Inizio'}
                    />
                  )}
                </FormItem>
              </Col>
              <Col span={8}>
                <FormItem label="Data Fine">
                  {getFieldDecorator('endDate', { 
                    rules: [{ required: true, message: 'Inserire la data di fine dell\'attività didattica'},
                    { validator: this.checkStartDate }] 
                    })(
                    <DatePicker 
                      format={shortDate} 
                      disabledDate={this.disabledDate}
                      defaultPickerValue={rangeyrs.minDate}
                      placeholder={'Data Fine'}
                    />
                  )}
                </FormItem>
              </Col>
            </Row>
            <Row gutter={16}>
              <Col span={24}>
                <Table
                  bordered
                  dataSource={occorrenze}
                  columns={columns}
                  className={tableStyle}
                  rowKey="rId"
                  rowClassName="form-table"
                  footer={() => <Button onClick={this.handleAddRow}>Aggiungi</Button>}
                  pagination={false}
                  size="small"
                />
                {
                  this.state.hasErrors &&
                  <div className="error-explain ant-form-explain">
                    <span>Inserire almeno un'attività ricorrente. Tutti i campi sono obbligatori.</span>
                  </div>
                }
              </Col>
            </Row>
            <div className="bottom-last" style={{ width: '70%' }}>
              <Button
                type="primary"
                htmlType="submit"
                style={{ marginRight: '10px' }}
              >
                Conferma
              </Button>
              <Button onClick={this.closeDrawer}>Chiudi</Button>
            </div>
          </Form>
        </Drawer>
      </div>
    );
  }
}

WeeklySchedule.propTypes = {
  registryInfo: PropTypes.object.isRequired,
  registryOccurrences: PropTypes.arrayOf(PropTypes.object),
  formeDidScheduled: PropTypes.arrayOf(PropTypes.object),
  onSaveClick: PropTypes.func.isRequired,
  centered: PropTypes.bool,
  title: PropTypes.object,
};

const WrappedRecurrentActivity = Form.create()(WeeklySchedule);

export default WrappedRecurrentActivity;
